import { Component } from 'react';

// STYLES
import {
  CollapsibleListWrapper,
  CollapsibleListTitle,
  CollapsibleListIcon,
  CollapsibleListBody,
  COLLAPSIBLE_LIST_CLASSES,
} from './CollapsibleList.styles';

class CollapsibleList extends Component {
  static defaultProps = {
    titleWrapper: <div />,
  };

  state = {
    collapsed: true,
  };

  handleTitleClick = () =>
    this.setState({
      collapsed: !this.state.collapsed,
    });

  render() {
    // @ts-expect-error TS(2339): Property 'TitleWrapper' does not exist on type 'Re... Remove this comment to see the full error message
    const { TitleWrapper } = this.props;
    const iconClass = this.state.collapsed ? 'icon-caret-down' : 'icon-caret-up';
    const listBodyClass = this.state.collapsed ? COLLAPSIBLE_LIST_CLASSES.COLLAPSED : COLLAPSIBLE_LIST_CLASSES.EXPANDED;

    return (
      <CollapsibleListWrapper>
        <CollapsibleListTitle onClick={this.handleTitleClick}>
          <TitleWrapper>
            {/* @ts-expect-error TS(2339): Property 'title' does not exist on type 'Readonly<... Remove this comment to see the full error message */}
            {this.props.title}
            <CollapsibleListIcon className={iconClass} />
          </TitleWrapper>
        </CollapsibleListTitle>
        <CollapsibleListBody className={listBodyClass}>{this.props.children}</CollapsibleListBody>
      </CollapsibleListWrapper>
    );
  }
}

export default CollapsibleList;
